import React from 'react';
import clsx from 'clsx';
import { Icon, IconSize } from '../../icon';
import { is } from '../../../services';
import { getColorClassName } from '../../../objects';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * ListItem Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode}
 * @param customIcon {IconName} Icon name
 * @param status {ListIconStatus} Status success|error
 * @param title {string} List item title
 * @param description {string} List item description
 */
const ListItem = ({ className, children, customIcon, status, title, description, testId, }) => {
    const { styled } = useTrilogyContext();
    const classes = clsx(is(getColorClassName(status)), className);
    if (customIcon) {
        return (React.createElement("li", { "data-testid": testId, className: hashClass(styled, clsx(classes)) },
            React.createElement(Icon, { className: classes, name: customIcon, size: IconSize.SMALL }),
            React.createElement("span", null, children)));
    }
    if (title || description) {
        return (React.createElement("li", { className: hashClass(styled, clsx(classes)) },
            React.createElement("b", null, title),
            React.createElement("p", null, children || description),
            React.createElement("br", null)));
    }
    return React.createElement("li", { className: hashClass(styled, clsx(classes)) }, children);
};
export default ListItem;
//# sourceMappingURL=ListItem.js.map